import { CheckCircleOutline } from '@mui/icons-material'
import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import { ClipLoader } from 'react-spinners'
import { theme } from '../../contexts/themeContext'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
}

const StatusModal = ({ open, onClose, active, name, status, onConfirm }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Stack direction="row" justifyContent="center">
          {status === 'unsent' && (
            <Typography id="modal-modal-title" variant="body1" component="h3">
              {active ? "Turn off notifications" : "Turn on notifications"} for {name}
            </Typography>
          )}
          {status === 'sending' && <ClipLoader color={theme.palette.text.primary} />}
          {status === "done" && <CheckCircleOutline fontSize='large' color='primary'/>}
        </Stack>
        <Stack sx={{ marginTop: 4 }} justifyContent="center" direction="row" spacing={2}>
          {status === "unsent" && <Button onClick={onConfirm} variant="outlined" color="primary">
            OK
          </Button>}
          <Button onClick={onClose} variant="outlined" color="error">
            {status === "unsent" ? "Cancel" : "Close"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default StatusModal
